require('jquery-custom-select');
//
jQuery( 'body' ).on( 'added_to_cart', function( e, fragments, cart_hash, this_button ) {
    alert('product added to cart');
} );
$(document).ready(function(){

    // sous menu header
    if ($(window).width() < 1200) {
        $('.main_ul .e-shop').on('click', function(e){
            e.preventDefault();
            $('.sub-menu').addClass('menu-open');
        });
    } else {
        $('.main_ul .e-shop').on('click', function(e){
            e.preventDefault();
            $('.sub-menu').toggle();
        });
        $(document).mouseup(function(e) 
        {
            var container = $(".sub-menu");
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) 
            {
                container.hide();
            }
        });
    }
    

    //banner slider

    $('.banner_slides').owlCarousel({
        loop:false,
        nav:true,
        dots:false,
        
        items : 1,
        navText : ['<i class="fal fa-chevron-left"></i>','<i class="fal fa-chevron-right"></i>'],
        responsive : {
            // breakpoint from 0 up
            0 : {
                nav:false,
                dots:true,
            },
            768 : {
                nav:true,
                dots:false,
            }
        }
    })

    //new-products slider
    if ($(window).width() > 991) {
        $('.new-products .woocommerce .products').owlCarousel({
            loop:false,
            nav:true,
            dots:false,
            items : 2,
            margin:30,
            navText : ['<i class="fal fa-chevron-left"></i>','<i class="fal fa-chevron-right"></i>'],
            responsive : {
                // breakpoint from 0 up
                0 : {
                    items : 1
                },
                768 : {
                    items : 2
                }
            }
        });
    }

    
    //sous menu footer
    $('.menu-item-has-children > a').on('click',function(e){
        e.preventDefault();
        var thisUl = $(this).parent().find('ul');
        //close all
        $('.menu-item-has-children > a').not(this).removeClass('open');
        $('.menu-item-has-children ul').not(thisUl).slideUp();
        //open
        $(this).toggleClass('open');
        thisUl.slideToggle();
    });
    // cacher résumé du panier
    $('.widget_shopping_cart').append('<a class="closewidget">Fermer ></a>');
    $(document).mouseup(function(e) 
    {
        var container = $(".widget_shopping_cart");
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
            container.removeClass('showme');
        }
    });
    $('.closewidget').on('click',function(e){
        e.preventDefault();
        $(".widget_shopping_cart").removeClass('showme');
    });

    // readmore JS
    $('.description_txt').readmore({ 
        lessLink: '<a href="#">'+ woocommercejs.readless + '</a>',
        moreLink: '<a href="#">'+ woocommercejs.readmore + '</a>',
        collapsedHeight: 50
    });
    
    // plus minus quantity
    $('.woocommerce').on('click','.button_plus', function(e){
        e.preventDefault();
		// if ($(this).prev().val() < 3) {
        $(this).prev().val(+$(this).prev().val() + 1);
        $(this).prev().trigger('change');
		// }
    });
    $('.woocommerce').on('click','.button_minus', function(e){
        e.preventDefault();
		if ($(this).next().val() > 1) {
            if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
            $(this).next().trigger('change');
        }
        
    });

    //Filtres ajax
    // FIltres e-shop
     $('.loading').hide();
     window.applyFilters = function() {
        var filter = $('#filter');
        
        data = filter.serialize();


       $.ajax({
           url:filter.attr('action'),
           data:filter.serialize()+'&orderby='+$('select.orderby').val(), // form data
           type:filter.attr('method'), // POST
           beforeSend:function(xhr){
               // filter.find('button').text('Processing...'); // changing the button label
               // console.log(xhr);
               $('.loading').css('display','inline-block');
               $('ul.products').css('opacity','0.3');
            //    var nbitems = 0;
           },
           success:function(data){
               // filter.find('button').text('Filtrer'); // changing the button label back
               
               
              
               $('#response').html(data); // insert data
               var nbitems = $('.product').length;
               if(nbitems<=1){
                   txtarticle = ' article';
               }else{
                   txtarticle = ' articles';
               }
               $('.woocommerce-result-count').text(nbitems + txtarticle);
               $('.loading').hide();
               $('ul.products').css('opacity','1');
               $('.sidebar_filtres,.filters_toggle').toggleClass('open');
            //    setTimeout(function(){ 
            //     $('.sidebar_filtres').removeClass('menu-open');
            //     $('.site-header').removeClass('menu-open');
            //    }, 1500);
               
           }
       });
       return false;
    }

    $('#filter input[type="checkbox"]').click(function(){
       applyFilters();
   });
   

   //

   $('.filters_toggle').on('click',function(e){
       e.preventDefault();
       $(this).toggleClass('open');
       $('.sidebar_filtres').toggleClass('open');
   });

    // Tri a droite page produits
    var $select = $('select.orderby');

    $select.customSelect({
        hideCallback: function () {
            applyFilters();
        }
    });

    var timeout;

    
    $('.woocommerce').on('change','input.qty', function(){

		if ( timeout !== undefined ) {
			clearTimeout( timeout );
		}
 
		timeout = setTimeout(function() {
            $("[name='update_cart']").removeAttr("disabled");
			$("[name='update_cart']").trigger("click");
			
		}, 500 ); // 1 second delay, half a second (500) seems comfortable too
 
    });

    //

    $('.wpcf7-form').find('input,textarea').on('input', function (e) {
        $(e.currentTarget).parent().attr('data-empty', !e.currentTarget.value);
        $(e.currentTarget).attr('data-empty', !e.currentTarget.value);
        
    });
    $('.wpcf7-form').find('input,textarea').on('focus', function (e) {
        $(e.currentTarget).parent().addClass('focus');
    });
    $('.wpcf7-form').find('input,textarea').on('blur', function (e) {
        $(e.currentTarget).parent().removeClass('focus');
    });

    //

    $('.search-launcher').on('click', function(e){
        $('.search_form_wrapper').addClass('showme');
        $('.search-field').focus();
    });
    $(document).mouseup(function(e) 
    {
        var container = $(".search_form_wrapper");
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
            container.removeClass('showme');
        }
    });


    //
    var Masonry = require('masonry-layout');
    if($('.lws-feed-list').length){
        var msnry = new Masonry( '.lws-feed-list', {
            // options...
          });

    }

    // limite les caracteres du fil d'ariane
    var txtLength = ($(".breadcrumb_last").text().length);
    if(txtLength > 25){
        $(".breadcrumb_last").text(function(index, currentText) {
        
            return currentText.substr(0, 25) + '...';
    
        });
    }
    
    //menu toggle
    $('.menu-toggle').on('click', function(e){
        e.preventDefault();
        $(this).toggleClass('menu-toggle-active');
        $('.main-navigation,.site-header').toggleClass('menu-open'); 
    });
    $('.menu-close').on('click', function(e){
        e.preventDefault();
        $('.menu-toggle').removeClass('menu-toggle-active');
        $('.main-navigation,.site-header').removeClass('menu-open'); 
    });
    //filtres
    $('.open_filters').on('click', function(e){
        e.preventDefault();
        $(this).toggleClass('filters-open');
        $('.sidebar_filtres,.site-header').toggleClass('menu-open'); 
    });
    // referme tout en cliquant en dehors des éléments
    $(document).mouseup(function(e) 
    {
        var container = $(".main-navigation,.menu-toggle,.sub-menu,.sidebar_filtres");
        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
            // container.removeClass('menu-open');
            $('.main-navigation').removeClass('menu-open');
            $('.sidebar_filtres').removeClass('menu-open');
            $('.site-header').removeClass('menu-open');
            $('.sub-menu,.sub-menu .col ul').removeClass('menu-open');
            $('.menu-toggle').removeClass('menu-toggle-active');
        }
    });

    // submenu mobile
    if ($(window).width() < 1200) {
        
        $('.sub-menu .col').on('click', function(e){
            var backarrow = $(".back-sub-menu");
            if (!backarrow.is(e.target) && backarrow.has(e.target).length === 0) {
                $(this).find('ul').addClass('menu-open');
            }
        });
        $('.sub-menu .col h4>a').on('click', function(e){
            e.preventDefault();
            $(this).next('ul').addClass('menu-open');
        });
        
        $('.sub-menu .col').each(function(){
            $(this).find('ul').prepend('<a href="#" class="back-sub-menu"><i class="fas fa-arrow-left"></i></a>');
        });

        
    }
    //btn retour
    $('.back-main-menu,.back-sub-menu').on('click', function(e){
        e.preventDefault();
        $(this).parent().removeClass('menu-open');
    });
    //close filters
    $('.close_filters').on('click', function(e){
        e.preventDefault();
        $(this).parent().removeClass('menu-open');
        $('.site-header').removeClass('menu-open');
    });
    
});
    
